import { deepCopy } from "../../helpers/object"
import { ADD_PATH_CACHE, REMOVE_PATH_CACHE, CLEAR_PATH_CACHES } from "./types"

const initialState = {
  /**
   * '/any-path/example': {
   *   scrollTop: 1234, || or undefined
   *   data: {
   *     anyStateVariableName: anyValue,
   *   }
   * }
   */
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_PATH_CACHE: {
      const { key, allowedPathnames, scrollTop, data } = action.payload
      return {
        ...state,
        pathCaches: {
          ...state.pathCaches,
          [key]: {
            allowedPathnames,
            scrollTop,
            data
          }
        }
      }
    }

    case REMOVE_PATH_CACHE: {
      const { key } = action.payload
      if (state?.pathCaches != null && state?.pathCaches[key] != null) delete state?.pathCaches[key]
      return {
        ...state,
        pathCaches: {
          ...state.pathCaches
        }
      }
    }

    case CLEAR_PATH_CACHES: {
      const { pathname } = action.payload
      if (state?.pathCaches == null || pathname == null) {
        return {
          ...state,
          pathCaches: undefined
        }
      }

      let pathCaches = deepCopy(state.pathCaches)
      for (let key in pathCaches) {
        if (pathCaches[key]?.allowedPathnames == null || pathCaches[key]?.allowedPathnames.indexOf(pathname) < 0) {
          delete pathCaches[key]
        }
      }

      return {
        ...state,
        pathCaches
      }
    }

    default:
      return state
  }
}
export default reducer
